import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hydrateFromStorage, loginRequested, selectAuth } from "../../../../pages/Auth/slice";
import { useNavigate } from "react-router-dom";
import LoginForm from "../components/LoginFormCN";

export default function LoginContainerCN() {
  const dispatch = useDispatch();
  const nav = useNavigate();
  const { status, error, token } = useSelector(selectAuth);

  useEffect(() => { dispatch(hydrateFromStorage()); }, [dispatch]);
  useEffect(() => { if (token) nav("/cn/profiling"); }, [token, nav]);

  return (
    <div className="loginfield">
      <LoginForm onSubmit={(p)=>dispatch(loginRequested(p))} loading={status==="loading"} />
      {error && <p className="">{error}</p>}
    </div>
  );
}